<template>
    <div v-if="state.message_sent" class="message-sent">{{ state.message_sent }}</div>
    <div :class="colorText">
        <div class="input-field mb-14">
            <div class="rounded-[6px] w-full overflow-hidden ">
                <input v-model="state.name" type="text" placeholder="Nome"
                    class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.name.$errors" :key="error.$uid">
                <div class="error-msg">Inserire Nome</div>
            </div>
        </div>
        <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.lastName" type="text" placeholder="Cognome"
                    class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.lastName.$errors" :key="error.$uid">
                <div class="error-msg">Inserire Cognome</div>
            </div>
        </div>
        <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.born" type="date" placeholder="Data di nascita"
                    class="p-4 w-full text-1.6rem bg-transparent text-slate-400" />
            </div>
            <div class="input-errors" v-for="error of v$.born.$errors" :key="error.$uid">
                <div class="error-msg">Inserire data di nascita</div>
            </div>
        </div>
        <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.phone" type="text" placeholder="Telefono"
                    class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.phone.$errors" :key="error.$uid">
                <div class="error-msg">Inserire Numero di telefono</div>
            </div>
        </div>
        <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.contact.email" type="text" placeholder="Email"
                    class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.contact.email.$errors" :key="error.$uid">
                <div class="error-msg">Controllare che l'email sia corretta</div>
            </div>
        </div>
        <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.citta" type="text" placeholder="Città"
                    class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.citta.$errors" :key="error.$uid">
                <div class="error-msg">Inserire la città</div>
            </div>
        </div>
        <div class="input-field mb-14">
            <label class="p-4 w-full text-1.6rem bg-transparent text-slate-400">Attività</label>
            <select v-model="state.activity" class="w-full p-4 bg-transparent">
                <option v-for="(option, index) in state.activityOptions" :key="index" :value="option.val">
                    {{ option.name }}
                </option>
            </select>
            <div class="input-errors" v-for="error of v$.activity.$errors" :key="error.$uid">
                <div class="error-msg">Controllare che il corso sia inserito</div>
            </div>
        </div>
        <div class="input-text">
            <div class=" rounded-[6px]  w-full overflow-hidden mb-14 bg-transparent">
                <textarea v-model="state.message" placeholder="Messaggio"
                    class="p-4 w-full text-1.6rem min-h-[15rem] bg-transparent"></textarea>
            </div>
        </div>
        <div class="input-text">
            <label class="
                  w-full
                  flex flex-col
                  items-center
                  px-4
                  py-5
                  
                 
                  tracking-wide
                  uppercase
                  border-b
                  hover:text-azzurro-logo
                  border-white
                  cursor-pointer
                  text-white
                  ease-linear
                  transition-all
                  duration-150
                  bg-transparent
                  my-8
                ">
                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                <span class="mt-2 text-base leading-normal hover:underline">{{ state.file ? 'Pronto per essere inviato'
        :
        'Seleziona File' }}</span>
                <p class="text-lg lg:text-xs">
                    INVIO ALLEGATO max 1500kb
                </p>
                <input type="file" class="hidden" refs="file" @change="handleFileUpload($event)" />
            </label>
        </div>
        <div class="wrap-privacy flex flex-col">
            <div class="privacy flex items-center justify-center mb-8">
                <input id="privacy" type="checkbox" v-model="state.privacy">
                <label for="privacy"><span class="ml-2 block">Ho letto l'Informativa e acconsento al trattamento
                        <br />dei dati per la finalità indicata.</span></label>
            </div>
            <div class="w-full flex flex-wrap flex-col">
                <div v-show="v$.privacy.$dirty && !state.privacy" class="input-errors">
                    <p class="error-msg text-center -mt-6">Attiva il consenso</p>
                </div>
            </div>
        </div>
        <div class="max-w-md m-auto mb-20">
            <button class="bg-azzurro-logo text-white text-xl w-full p-4 flex items-center justify-center send-email"
                :disabled="state.isLoading" @click.prevent="submitForm(v$)">Invia</button>
        </div>
        <div v-if="state.message_sent" class="message-sent">{{ state.message_sent }}</div>
        <loader :loading="state.isLoading" />
    </div>

</template>

<script>
import { reactive } from 'vue' // "from '@vue/composition-api'" if you are using Vue 2.x
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, maxLength } from '@vuelidate/validators'
import { kMaxLength } from 'buffer'
import axios from 'axios'
export default {
    name: 'form-contatti',
    props: {
        colorText: {
            type: String,
            default: 'text-white',
        }
    },
    setup(props) {
        const state = reactive({
            isLoading: false,
            message_sent: '',
            name: '',
            lastName: '',
            contact: {
                email: ''
            },
            citta: '',
            phone: '',
            born: '',
            activityOptions: [
                { name: 'Seleziona Attività', val: '' },
                { name: 'STUDIO EMME ACADEMY', val: 'Studio Emme Academy' },
                { name: 'CORSI SETTIMANALI', val: 'Corsi Settimanali' },
                { name: 'JUNIOR', val: 'Junior' },
                { name: 'ACTING IN ENGLISH', val: 'Acting in English' },
                { name: 'WORKSHOP', val: 'Workshop' },
                { name: 'ACTING CINEMA BASE', val: 'Acting Cinema Base' },
                { name: 'DIZIONE', val: 'Dizione' },
                { name: 'MANAGEMENT', val: 'Management' },
                { name: 'PRODUZIONE', val: 'Produzione' },
            ],
            activity: '',
            message: '',
            file: '',
            privacy: false
        })
        const resetForm = (v$) => {
            v$.$reset(); // Reimposta lo stato di validazione di Vuelidate
            state.isLoading = false
            state.name = ''
            state.lastName = ''
            state.born = ''
            state.contact.email = ''
            state.citta = ''
            state.phone = ''
            state.message = ''
            state.activity = ''
            state.file = ''
            state.privacy = false
        };


        const rules = {
            name: { required }, // Matches state.firstName
            lastName: { required }, // Matches state.lastName
            born: { required },
            contact: {
                email: { required, email } // Matches state.contact.email
            },
            citta: { required },
            phone: {
                required,
                minLength: minLength(5),
                maxLength: maxLength(10)

            },
            activity: { required },
            privacy: { required }

        }

        const handleFileUpload = (event) => {
            console.log(event.target.files[0]);
            state.file = event.target.files[0];
        }

        const submitForm = (v$) => {
            state.isLoading = true
            state.message_sent = ''
            v$.$validate().then((success) => {
                if (success) {
                    // Form is valid, perform form submission
                    const { name, lastName, born, contact, citta, phone, message, activity, privacy, file } = state
                    const url = `${process.env.WORDPRESS_BASE_URL}/wp-admin/admin-ajax.php`
                    
                    debugger

                    gtag('set', 'user_data', {
                        "email": contact.email,
                        "phone_number": phone,
                        "address":{
                        "first_name": contact.name,
                        "last_name":contact.lastName,
                        "city": citta,
                        }
                    });


            const data = {
                action: 'send_email',
                name: name,
                lastName: lastName,
                born: born,
                email: contact.email,
                citta: citta,
                phone: phone,
                activity: activity,
                message: message,
                privacy: privacy,
                file: file,
            }
            let formData = new FormData();
            formData.append("name", name);
            formData.append("lastname", lastName);
            formData.append("phone", phone);
            formData.append("mail", contact.email);
            formData.append("age", born);
            formData.append("city", citta);
            formData.append("message", message);
            formData.append("activity", activity);
            formData.append("privacy", privacy);
            formData.append("file", file);
            formData.append("action", 'send_email');

            axios
                .post(url, formData, {
                    headers: {


                    },
                })
                .then(function (response) {
                    const { success, message } = response.data
                    if (success) {
                        // Email inviata con successo
                        state.message_sent = message
                        resetForm(v$)
                    } else {
                        // Errore nell'invio dell'email
                        console.error(message);
                    }

                    state.isLoading = false

                })
                .catch(function (error) {
                    // Errore nella chiamata Axios
                    console.error('Errore nella chiamata Axios:', error);
                    state.isLoading = false
                });
        }
                else {
        state.isLoading = false
    }
})
        };

const v$ = useVuelidate(rules, state)

return {
    state,
    handleFileUpload,
    submitForm,
    resetForm,
    rules,
    v$
}
    },
    /*methods: {
        async submit () {
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        console.log('result in if', result)        
      }
      console.log(state)

      // perform async actions
    }
    }*/
}


</script>

<style lang="scss" scoped>
.message-sent {
    padding-bottom: 30px;
    font-weight: bold;
    color: lightgreen;
    text-align: center;
}

.error-msg {
    color: red;
}

.input-field {
    select {
        color: white;
        /* Cambia il colore del testo */
        background-color: #313131;

        &::-webkit-datetime-edit-fields-wrapper,
        &::-webkit-inner-spin-button,
        &::-webkit-calendar-picker-indicator {
            background-color: #313131;
            /* Cambia il colore della striscia di selezione */
        }

        /* Stili per la "striscia di selezione" su Firefox */
        &::-moz-focus-inner {
            background-color: #313131;
            /* Cambia il colore della striscia di selezione */
        }

        &t::-webkit-datetime-edit-fields-wrapper {
            background-color: #313131;
            /* Cambia il colore della striscia di selezione */
        }

        .option {
            background: #313131;
        }
    }
}
</style>